/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteApplicationInput = {
    applicationId: string;
};
export type Application_deleteApplication_MutationVariables = {
    input: DeleteApplicationInput;
};
export type Application_deleteApplication_MutationResponse = {
    readonly deleteApplication: {
        readonly application: {
            readonly id: string;
        };
    } | null;
};
export type Application_deleteApplication_Mutation = {
    readonly response: Application_deleteApplication_MutationResponse;
    readonly variables: Application_deleteApplication_MutationVariables;
};



/*
mutation Application_deleteApplication_Mutation(
  $input: DeleteApplicationInput!
) {
  deleteApplication(input: $input) {
    application {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteApplicationPayload",
    "kind": "LinkedField",
    "name": "deleteApplication",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Application",
        "kind": "LinkedField",
        "name": "application",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Application_deleteApplication_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Application_deleteApplication_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "13b59834c3786d7d0a6f1722018ed996",
    "id": null,
    "metadata": {},
    "name": "Application_deleteApplication_Mutation",
    "operationKind": "mutation",
    "text": "mutation Application_deleteApplication_Mutation(\n  $input: DeleteApplicationInput!\n) {\n  deleteApplication(input: $input) {\n    application {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f64715c663940927569e2fac4c251fbf';
export default node;
